export type PlatformRelatedDictionary = {
    mobile: boolean;
    desktop: boolean;
};

export type PlatformRelatedProp = boolean | PlatformRelatedDictionary;

export const getPlatformRelatedValue = (
    prop: PlatformRelatedProp
): PlatformRelatedDictionary => {
    if (typeof prop === "boolean") {
        return {
            mobile: prop,
            desktop: prop,
        };
    }
    return prop;
};
